import { useId } from "react";
import { Input, Label } from "@/components/ui";
import {
  applyWalletDateRangeChange,
  todayInputDate,
} from "@/lib/walletDateRange";

interface WalletDateRangeInputsProps {
  startDate: string;
  endDate: string;
  onChange: (range: { startDate: string; endDate: string }) => void;
  startLabel?: string;
  endLabel?: string;
  className?: string;
  inputClassName?: string;
  clampToToday?: boolean;
}

export function WalletDateRangeInputs({
  startDate,
  endDate,
  onChange,
  startLabel,
  endLabel,
  className = "grid gap-4 sm:grid-cols-2",
  inputClassName,
  clampToToday = true,
}: WalletDateRangeInputsProps) {
  const fieldId = useId();
  const startInputId = `${fieldId}-start`;
  const endInputId = `${fieldId}-end`;
  const today = todayInputDate();

  const handleStartChange = (value: string) => {
    onChange(
      applyWalletDateRangeChange(
        { startDate, endDate },
        "startDate",
        value,
        clampToToday,
      ),
    );
  };

  const handleEndChange = (value: string) => {
    onChange(
      applyWalletDateRangeChange(
        { startDate, endDate },
        "endDate",
        value,
        clampToToday,
      ),
    );
  };

  return (
    <div className={className}>
      <div>
        {startLabel ? (
          <Label htmlFor={startInputId} spacing="field">
            {startLabel}
          </Label>
        ) : null}
        <Input
          id={startInputId}
          type="date"
          value={startDate}
          max={endDate || (clampToToday ? today : undefined)}
          onChange={(e) => handleStartChange(e.target.value)}
          className={inputClassName}
        />
      </div>
      <div>
        {endLabel ? (
          <Label htmlFor={endInputId} spacing="field">
            {endLabel}
          </Label>
        ) : null}
        <Input
          id={endInputId}
          type="date"
          value={endDate}
          min={startDate || undefined}
          max={clampToToday ? today : undefined}
          onChange={(e) => handleEndChange(e.target.value)}
          className={inputClassName}
        />
      </div>
    </div>
  );
}
